import type { NpcId } from '@somnhold/content';

/**
 * The garrison cellars' scenes (docs/EXPEDICIONES.md, «La historia, con lo aprendido de la saga»): one before
 * going down and one coming back up. Each line is an i18n key and who says it; nobody says more than three in
 * a row (the client test checks it), and Hilde gives her name and trade before anything else.
 */
export interface CellarsLine {
  who: NpcId | 'narrator';
  key: string;
}

const L = (who: CellarsLine['who'], key: string): CellarsLine => ({ who, key: `exp.scene.${key}` });

/** By the courtyard well: who asks, where to go, what to bring up and why. */
export const CELLARS_OPENING: CellarsLine[] = [
  L('narrator', 'o1'),
  L('hilde', 'o2'),
  L('hilde', 'o3'),
  L('hilde', 'o4'),
  L('narrator', 'o5'),
  L('hilde', 'o6'),
  L('hilde', 'o7'),
];

/** The bell back in the bastion's bell tower. */
export const CELLARS_WON: CellarsLine[] = [L('narrator', 'w1'), L('hilde', 'w2'), L('narrator', 'w3'), L('hilde', 'w4')];

/** Coming up without it, by why it was lost. */
export const CELLARS_LOST: Record<'ink' | 'fallen' | 'gone' | 'other', CellarsLine[]> = {
  ink: [L('narrator', 'ink1'), L('hilde', 'ink2')],
  fallen: [L('narrator', 'fallen1'), L('hilde', 'fallen2')],
  gone: [L('narrator', 'gone1'), L('hilde', 'gone2')],
  other: [L('narrator', 'other1'), L('hilde', 'ink2')],
};

/** Every scene, for the tests. */
export const CELLARS_SCENES: CellarsLine[][] = [CELLARS_OPENING, CELLARS_WON, ...Object.values(CELLARS_LOST)];
